module.exports = __webpack_public_path__ + "img/plan.1011606f.svg";